/* eslint-disable react/require-default-props */
import React, { useCallback } from 'react';
import { FilterBar } from '@ui/organisms/FilterBar';
import { translate } from '@utils/i18n';
import { DEFAULT_DEFICIENCY_FILTERS } from '../types';
const NS = 'features.proposals.deficiencies_step';
const t = (key) => translate(key, { namespace: NS });
export function DeficienciesFiltersBar({ filters, onFiltersChange, assetsForSelect = [], severityOptions = [] }) {
    const handleDateRangeChange = useCallback((range) => {
        const toLocalDate = (d) => {
            if (!d)
                return null;
            // Date inputs and `new Date('YYYY-MM-DD')` are UTC midnight. DatePicker
            // values are local midnights. Use UTC parts only for the UTC-midnight case
            // so neither path shifts the calendar day.
            const isUtcMidnight = d.getUTCHours() === 0 &&
                d.getUTCMinutes() === 0 &&
                d.getUTCSeconds() === 0 &&
                d.getUTCMilliseconds() === 0;
            const year = isUtcMidnight ? d.getUTCFullYear() : d.getFullYear();
            const month = String((isUtcMidnight ? d.getUTCMonth() : d.getMonth()) + 1).padStart(2, '0');
            const day = String(isUtcMidnight ? d.getUTCDate() : d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };
        onFiltersChange(Object.assign(Object.assign({}, filters), { dateOpenedFrom: toLocalDate(range.start), dateOpenedTo: toLocalDate(range.end) }));
    }, [filters, onFiltersChange]);
    const handleSystemAssetsChange = useCallback((v) => {
        onFiltersChange(Object.assign(Object.assign({}, filters), { systemAssets: v.map(String) }));
    }, [filters, onFiltersChange]);
    const handleSeverityChange = useCallback((v) => {
        onFiltersChange(Object.assign(Object.assign({}, filters), { severity: v == null ? null : String(v) }));
    }, [filters, onFiltersChange]);
    const handleReset = useCallback(() => {
        onFiltersChange(DEFAULT_DEFICIENCY_FILTERS);
    }, [onFiltersChange]);
    const filterConfigs = [
        {
            type: 'dateRange',
            field: 'dateOpened',
            label: t('filters.date_opened'),
            value: {
                start: filters.dateOpenedFrom ? new Date(`${filters.dateOpenedFrom}T00:00:00`) : null,
                end: filters.dateOpenedTo ? new Date(`${filters.dateOpenedTo}T00:00:00`) : null
            },
            onChange: handleDateRangeChange
        },
        {
            type: 'treeMultiSelect',
            field: 'systemAsset',
            label: t('filters.system_asset'),
            value: filters.systemAssets,
            options: assetsForSelect,
            onChange: handleSystemAssetsChange
        },
        {
            type: 'select',
            field: 'severity',
            label: t('filters.severity'),
            value: filters.severity,
            options: severityOptions,
            onChange: handleSeverityChange
        }
    ];
    return (React.createElement("div", { className: "deficiencies-filters-bar", "data-testid": "deficiencies-filters-bar" },
        React.createElement(FilterBar, { filters: filterConfigs, onResetFilters: handleReset, toggleDisabled: true })));
}
